module.exports = __webpack_public_path__ + "img/picnic_table_with_us.b6a21a4f.png";